/* Board Mint-Hub view `apps` (desktop 1536): nội dung cách mép 40, top 96; lưới 3 cột gap 16; cột thông báo 360. */

.main {
  position: absolute;
  left: 40px;
  right: 40px;
  top: 96px;
  bottom: 32px;
  display: flex;
  gap: 24px;
}
.col {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.date {
  font-size: 13px;
  color: var(--lb);
}
.hello {
  margin: 2px 0 0;
  font-size: 28px;
  font-weight: var(--fw-title);
  letter-spacing: -0.02em;
}
.alert {
  padding: 10px 14px;
  border-radius: 12px;
  background: var(--err-bg);
  color: var(--err);
  display: flex;
  align-items: center;
  gap: 10px;
}
.alert b {
  flex-grow: 1;
  font-weight: var(--fw-label);
}
.retry {
  height: 32px;
  padding: 0 12px;
  border: 1px solid var(--bd);
  border-radius: 10px;
  background: var(--card);
  color: var(--tx);
  font: inherit;
  font-weight: var(--fw-label);
  cursor: pointer;
}

.search {
  height: 44px;
  max-width: 520px;
  padding: 0 14px;
  border-radius: 12px;
  background: var(--glass);
  box-shadow: var(--sh);
  color: var(--lb);
  display: flex;
  align-items: center;
  gap: 10px;
}
.search input {
  flex-grow: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--tx);
  font: inherit;
}
.none {
  padding: 12px 14px;
  border-radius: 12px;
  background: var(--glass);
  color: var(--lb);
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.tile {
  position: relative;
  min-height: 150px;
  padding: 20px;
  border-radius: 20px;
  background: var(--glass);
  box-shadow: var(--sh);
  color: var(--tx);
  text-decoration: none;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.tileTop {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.tileName {
  display: block;
  font-size: 20px;
  font-weight: var(--fw-title);
  letter-spacing: -0.01em;
}
.tileVal {
  margin-top: 2px;
  color: var(--tx2);
}
.go {
  position: absolute;
  right: 20px;
  bottom: 18px;
  color: var(--lb);
}

.rule {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.rule b {
  font-size: 15px;
  font-weight: var(--fw-title);
}
.rule span {
  flex-grow: 1;
  height: 1px;
  background: var(--bd);
}
.empty {
  color: var(--lb);
}

.news {
  width: 360px;
  flex-shrink: 0;
  align-self: flex-start;
  padding: 16px 16px 10px;
  border-radius: 20px;
  background: var(--glass);
  box-shadow: var(--sh);
}
.newsH {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: var(--fw-title);
}
.noNews {
  padding: 18px 0;
  text-align: center;
  color: var(--lb);
}

/* tài khoản */
.um {
  position: relative;
}
.user {
  height: 40px;
  padding: 0 12px 0 4px;
  border: 0;
  border-radius: 20px;
  background: var(--glass-soft);
  color: var(--tx);
  font: inherit;
  font-weight: var(--fw-label);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 240px;
}
.ini {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--pri-bg);
  color: var(--link);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.uname {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.scrim {
  position: fixed;
  inset: 0;
  z-index: 29;
}
.menu {
  position: absolute;
  right: 0;
  top: 46px;
  z-index: 30;
  width: 280px;
  padding: 6px;
  border-radius: 14px;
  background: var(--card);
  box-shadow: var(--pop);
}
.menuHead {
  padding: 8px 10px 10px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 4px;
}
.menuHead b {
  font-weight: var(--fw-label);
}
.menuHead div {
  font-size: 12px;
  color: var(--lb);
  overflow-wrap: anywhere;
}
.mi {
  width: 100%;
  min-height: 40px;
  padding: 0 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--tx);
  font: inherit;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.miErr {
  color: var(--err);
  font-weight: var(--fw-title);
}

@media (hover: hover) and (prefers-reduced-motion: no-preference) {
  .tile {
    transition: transform 200ms, box-shadow 200ms;
  }
  .tile:hover {
    transform: translateY(-2px);
    box-shadow: var(--sh-hi);
  }
  .mi:hover {
    background: var(--sub);
  }
}

@media (max-width: 1100px) {
  .news {
    display: none;
  }
}
@media (max-width: 820px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
/* Mint-Hub-Phone khung 2: lưới 2 cột thẻ 132, ô tìm 48, thông báo chung dưới lưới */
@media (max-width: 520px) {
  .main {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    bottom: auto;
    flex-direction: column;
    padding: 96px 16px 24px;
  }
  .col {
    gap: 12px;
  }
  .hello {
    font-size: 22px;
  }
  .search {
    height: 48px;
    padding: 0 12px;
    gap: 8px;
    max-width: none;
  }
  .search input {
    font-size: 16px;
  }
  .grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .tile {
    min-height: 132px;
    padding: 16px;
    gap: 10px;
  }
  .tileTop > * {
    width: 52px;
    height: 52px;
  }
  .tileName {
    font-size: 17px;
  }
  .tileVal,
  .go {
    display: none;
  }
  .rule b,
  .newsH {
    font-size: 16px;
  }
  .news {
    display: block;
    width: auto;
    align-self: stretch;
    padding: 0;
    background: transparent;
    box-shadow: none;
  }
  .newsH {
    margin: 0 0 8px;
  }
  .uname {
    display: none;
  }
  .user {
    width: 48px;
    height: 48px;
    padding: 0;
    justify-content: center;
    border-radius: 50%;
  }
  .ini {
    width: 48px;
    height: 48px;
    font-size: 15px;
  }
}
